import  { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import authReducer  from '../reducers/auth';
import picappReducer from '../reducers/picapp';
import eventReducer from '../reducers/event';
import participantsReducer from '../reducers/participants';
import contactsReducer from '../reducers/contacts';
import itemsReducer from '../reducers/items';
import todosReducer from '../reducers/todos';
// import filtersReducer from '../reducers/filters';
import { loadState } from './localStorage'

// If using Dev Tools, they will be assigned to composeEnhancers, if not it will set to simple compose.
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Load state from localStorage. This will happen upon each page refresh. Everytime
// we do a page refresh the app.js (application entry point) configureStore.js gets executed.
const persistedState = loadState();
// console.log("Just loaded state from localStorage. This is it");
// console.log(persistedState);

// This is where we create Redux Store. The first argument is either a single reducer or 
// combined reducers. The second argument is used to initialize state. In our case
// we are initializing redux state from local storage, using the loadState() function.
// Note the auth state is an object with properties such as,  uid and token.
export default () => {
    const store = createStore(
        combineReducers({
            auth:        authReducer,
            picapp:      picappReducer,
            event:       eventReducer,
            participants: participantsReducer,
            contacts:    contactsReducer,
            items:       itemsReducer,
            todos:       todosReducer,
        }),
        persistedState,
        composeEnhancers(applyMiddleware(thunk))  // configures store to use both devtools above and thunk
                                                  // If redux_devtools does not exist, it will simply use thunk
    );
    // console.log("Store was created. this is the state");
    // console.log(store.getState());

    return store;
}




// WEBPACK FOOTER //
// ./src/store/configureStore.js